import axiosInstance from "../mainService";
const questionService = {
    getQuestion(search, page, limit, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m152_questions/question/${sanitizedSearch}/${page}/${limit}/${company}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    getQuestionDetail(id){
        return axiosInstance.get('/data/m152_questions/question-detail/' + id);
    },
    totalAllQuestion(search, company) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m152_questions/question/${sanitizedSearch}/${company}`);
    },
    addAnswer(data){
        return axiosInstance.post('/insert-data/t106_question_details', data);
    },
    addQuestion(data){
        return axiosInstance.post('/insert-data/m152_questions', data);
    },
    updateQuestion(data){
        return axiosInstance.put('/update-data/m152_questions/'+data.id, data);
    },
    deleteQuestion(id){
        return axiosInstance.delete('/delete-data/m152_questions/' + id);
    },
    getAnswer(id){
        return axiosInstance.get('/answer-data/' + id);
    },
    getAnswerDetail(id){
        return axiosInstance.get('/question-detail/'+ id);
    },
    deleteAnswerbyQuestion(id){
        return axiosInstance.delete('/delete/t106_question_details/' + id);
    },
    deleteDetail(id){
        return axiosInstance.delete('/delete-data/t106_question_details/' + id);
    }
}

export default questionService;